import {AfterViewInit, Component, OnInit} from '@angular/core';
import {CommonConstants} from '../../../../../util/common-constants';
import {environment} from '../../../../../../environments/environment';
import {MatTabChangeEvent} from '@angular/material/tabs';
import {DateUtil} from '../../../../../util/date-util';
import {RegenradarBildMetadata} from '../../../../../model/regenradar/regenradar-bild-metadata';
import {FirebaseService} from '../../../../../service/firebase/firebase.service';
import {delay, first, take} from 'rxjs/operators';
import {MatSnackBar} from '@angular/material/snack-bar';
import {NavigationStart, Router} from '@angular/router';
import * as events from 'events';
import {AuthService} from '../../../../../service/auth/auth.service';

@Component({
  selector: 'app-radar-bilder',
  templateUrl: './radar-bilder-aktuell.component.html',
  styleUrls: ['../radar-bilder.css','./radar-bilder-aktuell.component.css']
})
export class RadarBilderAktuellComponent implements OnInit {


  imageMap;
  currentSize: string = 'm';
  currentType: string = 'gesamt';
  sizes = ['xs', 's', 'm', 'l', 'xl'];

  types = ['gesamt', 'norden', 'osten', 'sueden', 'westen'];

  private imagePath = '/wetter/regenradar/bilder/aktuell/deutschland/';
  private storageBasUrl = `${environment.storageBasePath}${environment.firebaseConfig.storageBucket}`;
  selectedImage: string;
  isLoading: boolean = false;

  constructor(private dateUtil: DateUtil, private firebaseService: FirebaseService,
              private snackbar: MatSnackBar, private router: Router) {
  }

  ngOnInit() {
    this.isLoading = true;
    setTimeout(() => {
      this.createUrls();
    }, 100);
  }

  /**
   * Baut die URLS zusammen
   * https://storage.googleapis.com/wetter-dts-dev-207755492.appspot.com/wetter/regenradar/bilder/aktuell/deutschland/l/2021-01-20T13:00:00_regenradar_tagesschau.de_gesamt_l.jpg
   * @private
   */
  private createUrls() {
    this.isLoading = true;
    this.imageMap = new Map();
    for (let type of this.types) {
      let imageList = [];
      for (let size of this.sizes) {
        let childPath = `${type}/${size}`;
        this.firebaseService.getFileListFromStorage(this.imagePath, childPath)
          .pipe(take(1))
          .subscribe(res => {
            res.items.reverse().forEach(item => imageList.push(new RegenradarBildMetadata(size, type, `${this.storageBasUrl}/${item.location.path}`)));
            this.isLoading = false;
          }, error => {
            this.snackbar.open(`ERROR: Regenradar ${error}`);
            this.isLoading = false;
          });
      }
      this.imageMap.set(type, imageList);
    }
  }

  onTabChange(tabChangeEvent: MatTabChangeEvent) {
    this.currentType = tabChangeEvent.tab.textLabel.toLocaleLowerCase();
  }

  formatRadarSizeLabel(value: number) {
    switch (value) {
      case 1:
        return 'XS';
      case 2:
        return 'S';
      case 3:
        return 'M';
      case 4:
        return 'L';
      case 5:
        return 'XL';
      default:
        return 'M';
    }
  }

  reload() {
   this.createUrls();
  }
}
